import axios from "axios";
import qs from "qs";
import { v4 as uuidv4 } from "uuid";
import md5 from "md5";
import Helper from "./../lib/helper";

export const extractTokenFromUrl = () => {
  if (typeof window === "undefined") return null;
  try {
    // 1. Direct JWT from URL
    const href = window.location.href || "";
    const match = href.match(/eyJ[a-zA-Z0-9_-]+?\.[a-zA-Z0-9_-]+?\.[a-zA-Z0-9_-]+/);
    if (match) {
      try { localStorage.setItem("token", match[0]); } catch (e) {}
      return match[0];
    }

    // 2. Query param ?token=... or ?access_token=... (or in hash)
    const searchParams = new URLSearchParams(window.location.search || "");
    const hashIdx = window.location.hash.indexOf("?");
    const hashParams = hashIdx !== -1
      ? new URLSearchParams(window.location.hash.slice(hashIdx))
      : new URLSearchParams();
    const queryToken = searchParams.get("token") || hashParams.get("token") ||
                       searchParams.get("access_token") || hashParams.get("access_token");
    if (queryToken && queryToken !== "null" && queryToken !== "undefined") {
      try { localStorage.setItem("token", queryToken); } catch (e) {}
      return queryToken;
    }

    // 3. Dot-separated token in pathname: e.g. /tai-nan-ho-gia-dinh.x3musb9l
    const pathname = window.location.pathname || "";
    const segments = pathname.split("/").filter(Boolean);
    const lastSegment = segments.pop() || "";

    if (lastSegment.includes(".")) {
      const dotParts = lastSegment.split(".");
      const candidate = dotParts.pop();
      const ignoredExts = ["html", "htm", "js", "css", "json", "png", "jpg", "jpeg", "svg", "ico"];
      if (candidate && !ignoredExts.includes(candidate.toLowerCase())) {
        try { localStorage.setItem("token", candidate); } catch (e) {}
        return candidate;
      }
    }

    // 4. Slash-separated token in pathname: e.g. /tai-nan-ho-gia-dinh/x3musb9l
    const knownRoutes = [
      "tai-nan-ho-gia-dinh",
      "tai-nan-gia-dinh",
      "bao-hiem-tai-nan-ho-gia-dinh",
      "an-gia-247",
      "bao-hiem-an-gia-247",
      "san-pham",
      "packeds",
      "intro"
    ];
    if (lastSegment && !knownRoutes.includes(lastSegment)) {
      try { localStorage.setItem("token", lastSegment); } catch (e) {}
      return lastSegment;
    }

    return null;
  } catch (e) {
    return null;
  }
};

export const getToken = () => {
  // 1. URL always takes priority
  const urlToken = extractTokenFromUrl();
  if (urlToken) return urlToken;

  // 2. Fallback to localStorage only if URL does not contain token
  try {
    const stored = localStorage.getItem("token") || localStorage.getItem("access_token") || sessionStorage.getItem("token");
    if (stored && stored !== "null" && stored !== "undefined") {
      return stored;
    }
  } catch (e) {}

  return "";
};

async function getStime(method, url, data) {
  let token = getToken();
  const res = await axios({
    method: 'GET',
    url: `${process.env.REACT_APP_OPEN_API}/v1/products/stime`,
    data: data,
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${token}`,
    },
  });
  return res;
}

const sortObjectByKey = (obj) => {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObject = {};
  sortedKeys.forEach((key) => {
    sortedObject[key] = obj[key];
  });
  return sortedObject;
};

async function apiCallOpenVerify(method, url, dataForm) {
  let token = getToken();
  const queryParams = Object.entries(dataForm || {})
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  // api lấy time và serectKey nếu có
  const dataStime = await getStime();
  if (dataStime.data.success) {
    const env = process.env.REACT_APP_NODE_ENV;
    const data = qs.stringify(sortObjectByKey(dataForm || {}));
    const uuid = uuidv4();
    const client = md5(env + "-" + data + dataStime.data.data.stime + uuid);
    const header = {
      "x-api-stime": dataStime.data.data.stime,
      "x-api-nonce": uuid,
      "x-api-client": client,
    }
    const res = await axios({
      method: method,
      url: `${process.env.REACT_APP_OPEN_API}${url}${(queryParams && method === 'GET') ? `?${queryParams}` : ""}`,
      data: dataForm,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${token}`,
        ...header
      },
    });
    return res;
  }
}

async function apiCallOpen(method, url, data) {
  let token = getToken();
  const res = await axios({
    method: method,
    url: `${process.env.REACT_APP_OPEN_API}${url}`,
    data: data,
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${token}`,
    },
  });
  return res;
}

async function apicall(method, url, data) {
  let token = getToken();
  const res = await axios({
    method: method,
    url: `${process.env.REACT_APP_SERVER_PRODUCT}${url}`,
    data: data,
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${token}`,
    },
  });
  return res;
}


async function apicall_upload_G2(method, url, data) {
  let token = getToken();
  const res = await axios({
    method: method,
    url: `${process.env.REACT_APP_G2DOMAIN}${url}`,
    data: data,
    headers: {
      Authorization: `bearer ${token}`,
    }
  });
  return res;
}

export default {
  apicall,
  apicall_upload_G2,
  apiCallOpen,
  apiCallOpenVerify
};